import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Imagesearch.module.css";
import { getImageUrl } from "../../lib/get-image";

const ImageSearchResults = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const products = location.state?.products || [];

  return (
    <div className={styles.page}>
      {/* HEADER */}
      <div className={styles.header}>
        {/* <h1>🔍 Search Results</h1>  */}
        {/* <p>{products.length} products found</p>  */}
      </div>

      {/* EMPTY STATE */}
      {products.length === 0 ? (
        <div className={styles.emptyState}>
          <div className={styles.icon}>📦</div>
          <h2>No Products Found</h2>
          <p>Try uploading a clearer image or different product</p>
        </div>
      ) : (
        <div className={styles.grid}>
          {products.map((p) => (
            <div
              key={p.id}
              className={styles.card}
              onClick={() =>
                navigate(`/productdetails/${p.slug}`)
              }
            >
              {/* IMAGE */}
              <div className={styles.imageBox}>
                <img
                  src={getImageUrl(p.thumb_image)}
                  alt={p.name}
                />
              </div>

              {/* INFO */}
              <div className={styles.info}>
                <h3>{p.name}</h3>

                {p.price && (
                  <div className={styles.price}>
                    ₹{p.price}
                  </div>
                )}

                <button className={styles.btn}>
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageSearchResults;